import React, { Component } from 'react'
import { Routes, Route } from 'react-router-dom'

import endPoints from '../../components/Consts/endPoints.json'

import { Exercise, ExerciseForm } from '../../views/Exercise'

export default class ExerciseRoute extends Component {
  render () {
    var releatedRoutes = endPoints.find(aa => aa.name == 'Exercise')?.routes
    return (
      <Routes>
        <Route path={releatedRoutes?.get} exact element={<Exercise />} />
        <Route path={releatedRoutes?.create} exact element={<ExerciseForm />} />
        <Route path={releatedRoutes?.update} exact element={<ExerciseForm />} />
        <Route path={releatedRoutes?.delete} exact element={<ExerciseForm />} />
      </Routes>
    )
  }
}
